import React, { useCallback, useMemo, useState } from "react";

const ConfirmModalContext = React.createContext({});

const DEFAULT_STATE = {
  action: () => {},
  isOpen: false,
  message: "",
  primaryButtonText: "",
  title: "",
};

export function ConfirmModalContextProvider({ children }) {
  const [state, setState] = useState(DEFAULT_STATE);
  const { action, message, primaryButtonText, isOpen, title } = state;

  const confirmAction = (theMessage, thePrimaryButtonText, theAction, theTitle = "") => {
    setState({
      action: theAction,
      isOpen: true,
      message: theMessage,
      primaryButtonText: thePrimaryButtonText,
      title: theTitle,
    });
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: somewhat lost to history
  const handleConfirm = useCallback(() => {
    action();
    setState(DEFAULT_STATE);
  }, [action, setState]);

  const handleCancel = () => setState(DEFAULT_STATE);

  // biome-ignore lint/correctness/useExhaustiveDependencies: same
  const contextValue = useMemo(
    () => ({
      confirmAction,
      handleCancel,
      handleConfirm,
      isOpen,
      message,
      primaryButtonText,
      title,
    }),
    [handleConfirm, message, isOpen, primaryButtonText, title],
  );

  return <ConfirmModalContext.Provider value={contextValue}>{children}</ConfirmModalContext.Provider>;
}

export default ConfirmModalContext;
